import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-resident-trip-list-filter',
	templateUrl: './resident-trip-list-filter.component.html',
	styleUrls: ['./resident-trip-list-filter.component.css'],
})
export class ResidentTripListFilterComponent extends FiltersComponent {
	@Input() destinations: Array<any> = [];
	statuses = [
		{ id: TripStatus.ALL, name: '(wszystkie)' },
		{ id: TripStatus.ACTIVE, name: 'Akytwne' },
		{ id: TripStatus.CANCELED, name: 'Anulowane' },
	];
	filters = {
		destination: null,
		dateFrom: null,
		dateTo: null,
		status: null,
	};
}

export enum TripStatus {
	ALL = '',
	ACTIVE = 'A',
	CANCELED = 'C',
}
